import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PresaleBox from '../components/PresaleBox';
import Bubble from '../components/Bubble';
import { IS_TEST_MODE, CONTRACT_ADDRESSES } from '../contracts/addresses';
import '../styles/home.css';
import '../styles/about.css';
import '../styles/noscroll.css';

// CONFIGURACIÓN CENTRALIZADA DE ESTILOS
const styles = {
  // PARA PC
  pc: {
    titulo: {
      padding: '0px',
      marginLeft: '-30px',
      marginTop: '-10px',
      fontSize: '38px',
      color: '#2196F3',
      fontWeight: 'bold',
      textAlign: 'left',
      position: 'absolute',
      top: '0px',
      left: '50px',
      zIndex: '10',
      width: 'auto'
    },
    presaleBox: {
      padding: '0px',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: '30px',
      width: '480px',
      height: 'auto',
      position: 'relative',
      top: '0',
      left: '0px',
      zIndex: '15',
      transform: 'scale(0.9)',
      display: 'flex',
      justifyContent: 'center'
    },
    burbuja1: {
      padding: '0px',
      marginLeft: '120px',
      marginTop: '0px',
      width: '480px',
      height: '250px',
      position: 'relative'
    },
    burbuja2: {
      padding: '0px',
      marginLeft: '120px',
      marginTop: '-60px',
      width: '480px',
      height: '720px',
      position: 'relative'
    },
    boton: {
      padding: '10px 20px',
      marginLeft: '-80px',
      marginTop: '-480px',
      marginBottom: '-100px',
      transform: 'scale(1)',
      width: 'auto',
      height: 'auto',
      position: 'absolute',
      display: 'inline-block',
      fontSize: '16px',
      fontWeight: 'bold',
      textAlign: 'center',
      borderRadius: '5px',
      backgroundColor: '#007bff',
      color: '#ffffff',
      textDecoration: 'none',
      cursor: 'pointer',
      border: 'none'
    }
  },
  // PARA MÓVIL
  mobile: {
    titulo: {
      padding: '0px',
      marginLeft: '50px',
      marginTop: '-50px',
      fontSize: '24px',
      color: '#2196F3',
      fontWeight: 'bold',
      textAlign: 'left',
      position: 'absolute',
      top: '60px',
      left: '0',
      zIndex: '10',
      width: 'auto'
    },
    presaleBox: {
      padding: '0px',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: '20px',
      width: '100%',
      height: 'auto',
      position: 'relative',
      top: '0',
      left: '0',
      zIndex: '15',
      transform: 'scale(0.9)',
      display: 'flex',
      justifyContent: 'center'
    },
    burbuja1: {
      padding: '0px',
      marginLeft: '18px',
      marginTop: '120px',
      transform: 'scale(1)',
      width: '90%',
      height: 'auto',
      position: 'relative'
    },
    burbuja2: {
      padding: '0px',
      marginLeft: '18px',
      marginTop: '20px',
      width: '90%',
      height: 'auto',
      position: 'relative'
    },
    boton: {
      padding: '10px 20px',
      marginLeft: '18px',
      marginTop: '30px',
      transform: 'scale(1)',
      width: '90%',
      height: 'auto',
      position: 'relative',
      display: 'block',
      fontSize: '16px',
      fontWeight: 'bold',
      textAlign: 'center',
      borderRadius: '5px',
      backgroundColor: '#007bff',
      color: '#ffffff',
      textDecoration: 'none',
      cursor: 'pointer',
      border: 'none'
    }
  }
};

const Home = () => {
  const { t } = useTranslation();
  const boxWidth = 480;
  const marginLeft = 20;

  // Detectar si es dispositivo móvil
  const [isMobile, setIsMobile] = React.useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    // Ocultar la barra de scroll solo en Home
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.documentElement.classList.add('no-scroll');
    document.body.classList.add('no-scroll');
    
    return () => {
      window.removeEventListener('resize', checkMobile);
      // Restaurar la barra de scroll al salir de Home
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.documentElement.classList.remove('no-scroll');
      document.body.classList.remove('no-scroll');
    };
  }, []);

  // Elegir el conjunto de estilos según el dispositivo
  const currentStyles = isMobile ? styles.mobile : styles.pc;

  return (
    <div className="about-page">
      {/* PancakeSwap iframe que ocupa toda la pantalla */}
      <div className="pancake-container">
        <iframe 
          src={IS_TEST_MODE 
            ? `https://pancakeswap.finance/swap?chain=bscTestnet&inputCurrency=${CONTRACT_ADDRESSES.usdt}&outputCurrency=${CONTRACT_ADDRESSES.token}`
            : `https://pancakeswap.finance/swap?chain=bsc&inputCurrency=${CONTRACT_ADDRESSES.usdt}&outputCurrency=${CONTRACT_ADDRESSES.token}`}
          width="100%" 
          height="100%"
          frameBorder="0"
          style={{
            border: 'none',
            margin: '0',
            padding: '0',
            display: 'block',
            position: 'relative',
            top: '0' /* Mantener el iframe alineado para que el header sea visible */
          }}
          title="PancakeSwap Trading"
        />
      </div>
    </div>
  );
};

export default Home;
